<template>
  <!-- 生成签约链接的dialog模态框 -->
  <el-dialog
    v-if="visible"
    title="岗位发布"
    :visible.sync="visible"
    :before-close="handleOuterClose"
    width="54%"
    custom-class="create_position"
    append-to-body
    class="create-task"
  >
    <div class="form-content">
      <div class="quick-create-btn">
        <el-popover
          placement="right"
          width="200"
          trigger="click">
          <el-select
              v-model="task_id"
              filterable
              clearable
              placeholder="请选择关联任务"
              @change="selectTask"
            >
              <el-option
                v-for="item in taskList"
                :label="item.title"
                :key="item.id"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button slot="reference"
              type="primary"
              size="mini"
              >快速创建
            </el-button>
        </el-popover>
        
      </div>
      <el-form
        ref="companyForm"
        :inline="true"
        :model="formData"
        label-width="100px"
      >
        <el-col :span="12" v-for="(item, index) in formList" :key="index">
          <el-form-item
            :label="item.label"
            :prop="item.props"
            :rules="[
              {
                required: item.required,
                message: '请输入' + item.label,
                trigger: 'blur',
              },
            ]"
          >
            <template v-if="item.type == 'input'">
              <el-input
              class="input"
                :placeholder="item.placeholder"
                v-model="formData[item.props]"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'textarea'">
              <el-input
              class="input"

                type="textarea"
                v-model="formData[item.props]"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'picker'">
              <el-select
              class="select"

                v-model="formData[item.props]"
                placeholder="请选择"
                clearable
                filterable
              >
                <el-option
                  v-for="(item1, index1) in item.selectOption"
                  :key="index1"
                  :label="item1.label"
                  :value="item1.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else-if="item.type == 'multiplePicker'">
              <el-select
              class="select"

                v-model="formData[item.props]"
                placeholder="请选择"
                clearable
                filterable
                multiple
              >
                <el-option
                  v-for="(item1, index1) in item.selectOption"
                  :key="index1"
                  :label="item1.label"
                  :value="item1.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else-if="item.type == 'cascader'">
              <el-cascader
              class="cascader"
                v-model="formData[item.props]"
                placeholder="请选择"
                clearable
                filterable
                :checkStrictly="true"
                :show-all-levels="false"
                :props="{ multiple: item.multiple }"
                :options="item.selectOption"
              >
              </el-cascader>
            </template>
            <template v-else-if="item.type == 'salary'">
              <div style="width: 240px;">
                <el-col :span="10">
                <el-input
                  class="salary-input"
                  v-model="formData.min_salary"
                  placeholder="最低薪资"
                />
                </el-col>
                <el-col :span="2" class="text-center">
                  <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    class="salary-input"
                    v-model="formData.max_salary"
                    placeholder="最高薪资"
                  />
                </el-col>
                <el-col :span="2">
                  <el-tooltip class="item" effect="dark" content="如若填写相同薪资，则展示固定薪资" placement="right">
                    <i class="el-icon-warning"></i>
                  </el-tooltip>
                </el-col>
              </div>
              
            </template>
            <template v-else-if="item.type == 'age'">
              <div style="width: 240px;">
                <el-col :span="10">
                <el-input
                  class="salary-input"
                  v-model="formData.min_age"
                  placeholder="最小年龄"
                />
                </el-col>
                <el-col :span="2" class="text-center">
                  <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    class="salary-input"
                    v-model="formData.max_age"
                    placeholder="最大年龄"
                  />
                </el-col>
              </div>
              
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="margin-bottom: 10px;padding-left: 20px;">
          <div style="margin-bottom: 6px;">
            职位介绍
          </div>
          <el-input
            type="textarea"
            rows="5"
            placeholder="请输入职位介绍"
            maxlength="200"
            show-word-limit
            v-model="formData.job_remark"
          >
          </el-input>
        </div>
        </el-col>
        
      </el-form>
      <div class="btn">
        <el-button
          size="medium"
          type="primary"
          :disabled="loadingStaus"
          @click="saveConfirm"
          >保存</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import json from "../../../../public/citys.json";
import { gettreeList, SALARY_TYPE_LIST } from "@/utils/utils";

export default {
  components: {},
  // props:{
  //   id: {
  //     type: String,
  //     default: '',
  //   },
  //   type: {
  //     type: String,
  //     default: '',
  //   },
  // },
  data() {
    return {
      taskList:[],
      task_id:'',
      tag_id:'',
      visible: false,
      json,
      formList: [
        {
          required: true,
          label: "岗位名称",
          type: "input",
          props: "recruit_post",
          value: "",
          placeholder: "请输入岗位名称",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位标签",
          type: "multiplePicker",
          props: "tag_ids",
          value: [],
          selectOption: [],
          placeholder: "请选择岗位标签",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "category_ids",
          value: [],
          multiple: true,
          selectOption: [],
          placeholder: "请选择行业类型",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "worked_num",
          value: "",
          placeholder: "请输入用工人数",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "年龄要求",
          props: "min_age",
          disabled: false,
          type: "age"
        },
        {
          required: true,
          label: "学历要求",
          type: "picker",
          props: "minimum_education",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: "1" },
            { label: "初中", value: "2" },
            { label: "高中", value: "3" },
            { label: "大专", value: "4" },
            { label: "本科及以上", value: "5" },
          ],
          placeholder: "请选择学历要求",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作地点",
          type: "cascader",
          props: "work_city",
          value_text_props: "address",
          value: "",
          selectOption: json.data,
          valueLevel: "more",
          placeholder: "请选择工作地点",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "详细地点",
          type: "input",
          props: "address",
          placeholder: "请输入详细地点",
          value: "",
          disabled: false,
          show: true,
        },
        // {
        //   label: "联系人",
        //   type: "input",
        //   props: "contact",
        //   placeholder: "请输入联系人",
        //   value: "",
        //   disabled: false,
        //   show: true,
        // },
        {
          label: "联系人电话",
          type: "input",
          props: "contact_number",
          placeholder: "请输入联系人电话",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "薪资范围",
          type: "salary",
          props: "min_salary",
          placeholder: "请输入薪资",
          value: "",
          show: true,
        },

        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: SALARY_TYPE_LIST,
          placeholder: "请选择结算方式",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位状态",
          type: "picker",
          props: "status",
          placeholder: "请选择岗位状态",
          selectOption: [
            { label: "未开始", value: 0 },
            { label: "进行中", value: 1 },
            { label: "已完成", value: 2 },
            { label: "已暂停", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作性质",
          type: "picker",
          props: "work_type",
          placeholder: "请选择工作性质",
          value_text_props: "work_type_name",
          selectOption: [
            { label: "全职", value: 1 },
            { label: "兼职", value: 2 },
            { label: "实习", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        // {
        //   label: "职位介绍",
        //   type: "textarea",
        //   props: "job_remark",
        //   placeholder: "请输入职位介绍",
        //   value: "",
        //   disabled: false,
        //   show: true,
        // },
      ],
      dialogVisible: false,
      activeTab: "0",
      hearTitle: "基本设置",
      loadingStaus: true,
      loadingText: "正在提交中……",
      formDisabled: false,
      billId: 0, // 公司id，0表示创建，非零为编辑
      // 公司基本信息表单结构
      formData: {},
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    open(type,id){
      this.type = type;
      this.id = id;
      this.visible = true;
      this.init();
    },
    //关闭外层dialog小×
    handleOuterClose() {
      this.$refs.companyForm.resetFields();
      this.visible = false;
      this.formData = {};
    },
    async getDailyTaskIndustryList() {
      let res = await this.$api.getDailyTaskIndustryList();
      this.formList[2].selectOption = gettreeList(
        res,
        "industry_type_name",
        "id"
      );
    },
    selectTask(e){
      let arr = this.taskList.filter(item => e == item.id)[0]
      this.formData = {
        ...this.formData,
        recruit_post:arr.title,
        work_city:[arr.province,arr.city,arr.area],
        minimum_education: '' + arr.min_qualification,
        min_salary: arr.min_salary,
        max_salary: arr.max_salary,
        worked_num: arr.person_num,
        address:arr.address,
        salary_type: parseInt(arr.salary_type),
      };
    },
    async getQuickMissionList() {
      let res = await this.$api.get_quick_mission_list();
      this.taskList = res
    },
    async getDailyPostTagList() {
      let res = await this.$api.getDailyPostTagList();
      this.formList[1].selectOption = gettreeList(res, "name", "id");
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v);
      if (v) {
        this.formData.parent_id = v;
      }
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs["companyForm"].validate((valid) => {
        if (valid) {
          if(!this.formData.max_salary){
            this.$message.error('请输入最高薪资金额')
            return;
          }
          if(!this.formData.min_salary){
            this.$message.error('请输入最大年龄')
            return;
          }
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true;
      console.log("formData -> ", this.formData);
      try {
        let param = {};
        if (this.formData.work_city[0]) {
          param = {
            province: this.formData.work_city[0],
            city: this.formData.work_city[1],
            area: this.formData.work_city[2],
          };
        }
        let cate_arr = [];
        if (Array.isArray(this.formData.category_ids[0])) {
          this.formData.category_ids.map((item) => {
            cate_arr.push(item[item.length - 1]);
          });
          this.formData.category_ids = cate_arr;
        }
        let res;
        if (this.id) {
          res = await this.$api.recruitTaskUpdate(this.id,{
            ...this.formData,
            ...param,
          });
        } else {
          res = await this.$api.recruitTaskAdd({
            ...this.formData,
            ...param,
          });
        }
        if (res) {
          this.$notify.success("保存成功！");
          this.$emit('confirm');
          this.handleOuterClose()
        }
        this.$nextTick(() => {
          this.loadingStaus = false;
        });
      } catch (err) {
        this.loadingStaus = false;

        console.log("err is ->", err);
      }
    },
    // 初始化公司基本信息
    async init() {
      this.formDisabled = this.$route.query.type === "details" ? true : false;
      if (this.id) {
        let data = await this.$api.recruitTaskDetail({ id: this.id });
        this.formData = data;
        this.formData.tag_ids = data.ph_hr_recruit_task_tag?.map((item) => item.tag_id);
        this.formData.category_ids = data.recruit_post_category_ids;
        console.log(this.formData.category_ids, 99999);
        this.formData.work_city = [data.province, data.city, data.area];
        this.formData.minimum_education = this.formData.minimum_education+'';
      }
    },
  },
  async mounted() {
    this.loadingStaus = true;
    this.getQuickMissionList();
    this.getDailyTaskIndustryList();
    this.getDailyPostTagList();
    this.$nextTick(() => {
      this.loadingStaus = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.el-icon-warning{
  margin: 5px 0 0 4px;
  color: #409EFF;
  font-size: 18px;
}
.text-center{
  text-align: center;
}
.form-content{
  .select,.input,.cascader{
    width: 220px;
  }
  .input.salary-input{
    width: 100%;
  }
 }
 .quick-create-btn{
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
}
.form-content {
  display: flex;
  flex-flow: column nowrap;
  .btn {
    display: flex;
    justify-content: center;
  }
}
</style>
